import React, { useState } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { configureStore } from "./store";
import { Provider } from "react-redux";
import { positions, transitions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
  transition: transitions.SCALE,
};
// let stripeApiKey;
// async function getStripeApiKey() {
//   const config = {
//     withCredentials: "true",
//   };
//   const { data } = await axios.get(
//     "https://ebuymait.herokuapp.com/api/v1/stripeapi",
//     config,
//   );
//   console.log("MAARDO MUJHE", data.stripeApiKey);

//   stripeApiKey = `${data.stripeApiKey}`;
//   console.log(typeof stripeApiKey);
// }

// getStripeApiKey();
const stripeApiKey =
  "pk_test_51JxoqdSGVWJVHcfidJ2SDKS9xgZyfgiW5v1EGSrFtX2t1z6jti9U2i7tNNbeiww4ThXy1DRHX9lMhEK7kOHUkYcL00C6j1jnsI";
const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
    <AlertProvider template={AlertTemplate} {...options}>
      <Elements stripe={loadStripe(stripeApiKey)}>
        <App />
      </Elements>
    </AlertProvider>
  </Provider>,
  document.getElementById("root"),
);
